import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  GetSupplyOrderDetailItemResponseType,
  GetSupplyOrderDetailResponseType,
  GetSupplyOrderRemarksResponseType,
} from 'features/SupplyOrder/services/outboundSO'
import { GetAllLocationsResponseType } from 'features/Location/services/location'
import {
  SLICE_NAME,
  fetchGetSupplyOrderDetail,
  fetchGetSupplyOrderType,
  fetchGetSupplyOrderDetailItem,
} from './thunk'

export type OutboundSODetailSliceType = {
  isLoading: boolean
  data: Nullable<GetSupplyOrderDetailResponseType['data']>
  products: {
    query: Partial<{
      pageIndex: number
      pageSize: number
      name: string
    }>
    item: GetSupplyOrderDetailItemResponseType['data']['content']
  }
  constants: {
    remarks: GetSupplyOrderRemarksResponseType['data']
    locations: GetAllLocationsResponseType
    type: string[]
  }
}

const initialState: OutboundSODetailSliceType = {
  isLoading: false,
  data: null,
  products: {
    query: {
      pageIndex: 0,
      pageSize: 10,
    },
    item: [],
  },
  constants: {
    remarks: [],
    locations: [],
    type: [],
  },
}

const outboundSODetailSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<OutboundSODetailSliceType>) => {
      builder.addCase(fetchGetSupplyOrderDetail.fulfilled, (state, { payload }) => {
        state.data = payload.data
      })
      builder.addCase(fetchGetSupplyOrderDetailItem.pending, (state, action) => {
        state.products.query = {
          ...state.products.query,
          ...action.meta.arg.params,
        }
      })
      builder.addCase(fetchGetSupplyOrderDetailItem.fulfilled, (state, { payload }) => {
        state.products.item = payload
      })
      builder.addCase(fetchGetSupplyOrderType.fulfilled, (state, { payload }) => {
        state.constants.type = payload
      })
    },
    [fetchGetSupplyOrderDetail, fetchGetSupplyOrderDetailItem],
  ),
})

export const { reset } = outboundSODetailSlice.actions
export default outboundSODetailSlice.reducer
